'use client'

import { FacetSelector } from '@src/components/ProductConfigurator/modules/FacetSelect/FacetSelect'
import { useLocale } from '@src/i18n/LocaleProvider'

/**
 * This component provides a FacetRenderer layout for the FacetSelector component
 */
export const FacetSelectorLayout: FacetLayout = ({ facetMeta, facetOptions, setFacetOption }) => {
  const { t } = useLocale('product-page')
  if (!facetOptions?.length) return null
  return (
    <div key={facetMeta.key}>
      <p className="pb-2 pt-4 font-medium text-bodi-gray-medium">{t(facetMeta.title)}</p>
      <FacetSelector
        facetKey={facetMeta.key}
        facetOptions={facetOptions}
        onFacetSelected={(facetSlug) => {
          const facetOption = facetOptions.find((option) => option.slug === facetSlug)
          if (facetOption) setFacetOption(facetMeta.key, facetOption)
        }}
      />
    </div>
  )
}
